import LandInfo from '../../../../component/report/LandInfo';
import { RowTable5 } from '../../../../component/report/Row';
const ReportDetail3 = ({ data }: { data: any }) => {
  return (
    <LandInfo.BuildingInfo data={data} title="건물정보" RowTable={RowTable5} />
  );
};

export default ReportDetail3;
